(() => {
  const rootSelector = ".bls__template-product";

  const parseJson = (element) => {
    if (!element) return null;
    try {
      return JSON.parse(element.textContent);
    } catch (_error) {
      return null;
    }
  };

  const getVariants = (root) => {
    const variantSelects = root.querySelector("variant-selects");
    if (variantSelects) {
      const variantJson = variantSelects.querySelector(
        'script[type="application/json"]:not(.productVariantsQty)'
      );
      const variants = parseJson(variantJson);
      if (Array.isArray(variants) && variants.length) return variants;
    }

    const productJson = parseJson(root.querySelector("[data-product-json]"));
    if (productJson && Array.isArray(productJson.variants)) return productJson.variants;

    return [];
  };

  const syncStockCountdown = (root) => {
    const countdown = root.querySelector("stock-countdown");
    if (!countdown) return;

    const message = countdown.dataset.message;
    const limit = Number(countdown.dataset.itemsLeft);
    const variantId = Number(
      root.querySelector('form[data-type="add-to-cart-form"] input[name="id"]')?.value
    );
    const variants = getVariants(root);
    const currentVariant =
      variants.find((variant) => Number(variant.id) === variantId) || variants[0];

    if (!message || !Number.isFinite(limit) || limit < 1 || !currentVariant) {
      countdown.classList.add("d-none");
      return;
    }

    const inventoryManaged =
      currentVariant.inventory_management !== null &&
      currentVariant.inventory_management !== undefined;
    const quantity = Number(currentVariant.inventory_quantity ?? 0);
    const canShow =
      currentVariant.available === true &&
      inventoryManaged &&
      quantity >= 1 &&
      quantity <= limit;

    if (!canShow) {
      countdown.classList.add("d-none");
      return;
    }

    countdown.classList.remove("d-none");

    const count = countdown.querySelector(".bls__count");
    if (count) count.textContent = quantity;

    const progress = countdown.querySelector(".progressbar-stock");
    if (progress) {
      progress.style.width = `${Math.min((quantity / limit) * 100, 100)}%`;
    }
  };

  const initRoot = (root) => {
    if (!root || root.dataset.stockFixInit === "true") return;
    root.dataset.stockFixInit = "true";

    const sync = () => syncStockCountdown(root);

    sync();

    root.addEventListener(
      "change",
      (event) => {
        if (event.target?.name === "id") {
          window.requestAnimationFrame(sync);
        }
      },
      true
    );

    root.addEventListener(
      "click",
      (event) => {
        if (event.target.closest(".bls__option-swatch")) {
          window.setTimeout(sync, 0);
        }
      },
      true
    );
  };

  const init = () => {
    document.querySelectorAll(rootSelector).forEach(initRoot);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", init);
})();
